import React, { useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet-async';
import { faFacebook, faTwitter, faYoutube, faInstagram, faPinterest } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar } from '@fortawesome/free-solid-svg-icons';
const PetBreeding = () => {
    const [selectedImage, setSelectedImage] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const { t } = useTranslation();

    return (
        <>
            <Helmet>
                <title>Pet Breeding Service | Find Dog & Cat Studs Near You | Pets Home App</title>
                <meta name="description" content="Connect with certified dog breeders and cat breeders. Find perfect breeding matches, stud services, and breeding partners for your pets. Download Pets Home App." />
                <meta name="keywords" content="dog breeders, cat breeders, stud dog service, stud cat, pet breeding, dog breeding, cat breeding, breeding partners, dog stud near me, cat breeding service" />
                <link rel="canonical" href="https://petshome.app/pet-breeding-services" />
            </Helmet>

            {/* Hero Section */}
            <section className="hero-section py-5 ">
                <Container>
                    <Row className="align-items-center">
                        <Col lg={7} className="mb-4 mb-lg-0">
                            <h1 className="display-4 fw-bold mb-3">{t("Find Perfect Breeding Partners for Your Pets")}</h1>
                            <p className="lead mb-4">{t("Connect with verified dog breeders and cat breeders. Our platform helps responsible pet owners find ideal breeding matches and stud services near you.")}</p>

                            <div className="d-flex flex-wrap mb-4">
                                <span className="badge bg-primary me-2 mb-2 p-2">{t("Certified Dog Breeders")}</span>
                                <span className="badge bg-primary me-2 mb-2 p-2">{t("Registered Cat Breeders")}</span>
                                <span className="badge bg-primary me-2 mb-2 p-2">{t("Stud Dog Services")}</span>
                                <span className="badge bg-primary me-2 mb-2 p-2">{t("Cat Breeding")}</span>
                                <span className="badge bg-primary me-2 mb-2 p-2">{t("Health-Verified Studs")}</span>
                            </div>
                            <h5 className="text-center font-weight-bold">{t('global.h5_dwonload')}</h5>
                            <div className="d-flex justify-content-center">
                                <a href="https://play.google.com/store/apps/details?id=com.app.petshome" target="_blank" rel="noopener noreferrer" className="mr-3" title="Download Pets Home App from Google Play Store">
                                    <img style={{ width: '180px', height: 'auto', marginRight: "10px" }} src="/google-play-badge.svg" alt="Download Pets Home App on Google Play" />
                                </a>
                                <a href="https://apps.apple.com/app/apple-store/id1549828591?pt=581834&ct=desktop&mt=8" target="_blank" rel="noopener noreferrer" title="Download Pets Home App from Apple App Store">
                                    <img style={{ width: '180px', height: 'auto' }} src="/app-store-badge.svg" alt="Download Pets Home App on App Store" />
                                </a>
                            </div>
                            <div className="d-flex justify-content-center">
                                {/* <small> {t('rated')} </small> */}
                                <div>
                                    <FontAwesomeIcon icon={faStar} color="gold" />
                                    <FontAwesomeIcon icon={faStar} color="gold" />
                                    <FontAwesomeIcon icon={faStar} color="gold" />
                                    <FontAwesomeIcon icon={faStar} color="gold" />
                                    <FontAwesomeIcon icon={faStar} color="gold" />
                                </div>
                            </div>
                            <div className="d-flex justify-content-center mt-4">
                                <img style={{ width: '130px', height: 'auto', marginRight: '10px' }} src="/android-adobe-express-qr-code.png" alt="Android QR Code" className="mr-3" />
                                <img style={{ width: '130px', height: 'auto' }} src="/ios-express-qr-code.png" alt="iOS QR Code" />
                            </div>
                            <p className="text-center mt-3 d-none d-md-block">{t('Scan the QR codes below for quick access:')}</p>


                            {/* Social Sharing Buttons */}
                            <div className="social-sharing text-center my-4">
                                <p>{t('global.share_p')}</p>
                                <a href="https://www.facebook.com/sharer/sharer.php?u=https://www.petshome.app/" target="_blank" rel="noopener noreferrer">
                                    <FontAwesomeIcon icon={faFacebook} size="2x" className="mx-2" />
                                </a>
                                <a href="https://twitter.com/intent/tweet?url=https://www.petshome.app/&text=Sell%20Your%20Pet%20Online%20for%20Free%20with%20Pets%20Home%20App" target="_blank" rel="noopener noreferrer">
                                    <FontAwesomeIcon icon={faTwitter} size="2x" className="mx-2" />
                                </a>
                                <a href="https://www.instagram.com/petshomeapp/" target="_blank" rel="noopener noreferrer">
                                    <FontAwesomeIcon icon={faInstagram} size="2x" className="mx-2" />
                                </a>
                                <a href="https://www.pinterest.com/petshomeapp/" target="_blank" rel="noopener noreferrer">
                                    <FontAwesomeIcon icon={faPinterest} size="2x" className="mx-2" />
                                </a>
                                <a href="https://www.youtube.com/channel/UCTjh3nmz0cVGaX0MnHl6elA" target="_blank" rel="noopener noreferrer">
                                    <FontAwesomeIcon icon={faYoutube} size="2x" className="mx-2" />
                                </a>
                            </div>
                        </Col>
                        <Col lg={5} className="text-center">
                            <img
                                className="img-fluid rounded shadow"
                                src="/assets/web/pets-matchmaking.png"
                                alt="Dog and Cat Breeding - Find Perfect Breeding Partners with Pets Home App"
                                style={{ maxWidth: '400px' }}
                            />
                        </Col>
                    </Row>
                </Container>
            </section>

            {/* Main Services Section */}
            <section className="services-section py-5">
                <Container>
                    <Row className="mb-5">
                        <Col md={12} className="text-center mb-4">
                            <h2 className="section-title fw-bold">Professional Pet Breeding & Matchmaking Services</h2>
                            <p className="lead">Connecting responsible dog breeders and cat breeders with ideal breeding partners</p>
                        </Col>
                    </Row>

                    <Row className="mb-5">
                        <Col md={6} className="mb-4 mb-md-0">
                            <div className="service-card h-100 p-4 border rounded shadow-sm">
                                <h3 className="text-primary mb-3">Dog Breeding Services</h3>
                                <p>Our platform connects you with certified dog breeders and quality stud dogs across all popular breeds. We help you find the perfect breeding match based on:</p>
                                <ul className="feature-list">
                                    <li><strong>Health Testing:</strong> All breeding dogs have verified health clearances</li>
                                    <li><strong>Temperament:</strong> Stable, breed-appropriate temperaments</li>
                                    <li><strong>Pedigree:</strong> Quality bloodlines for predictable offspring</li>
                                    <li><strong>Location:</strong> Find local dog breeders and stud services near you</li>
                                </ul>
                                <p><strong>Stud Fee Information:</strong> Most stud services range from $200-$2,500 depending on breed, champion status, and lineage. Our platform facilitates secure payment and breeding agreements.</p>
                            </div>
                        </Col>
                        <Col md={6}>
                            <div className="service-card h-100 p-4 border rounded shadow-sm">
                                <h3 className="text-primary mb-3">Cat Breeding Services</h3>
                                <p>Connect with reputable cat breeders and quality stud cats for your breeding program. Our platform features:</p>
                                <ul className="feature-list">
                                    <li><strong>Purebred Studs:</strong> Access to registered and health-tested male cats</li>
                                    <li><strong>Breeding Guidance:</strong> Expert advice on cat breeding seasons and compatibility</li>
                                    <li><strong>Local Services:</strong> Find cat breeders and stud services in your area</li>
                                    <li><strong>Health Guarantees:</strong> All listed cats have appropriate health screenings</li>
                                </ul>
                                <p><strong>Cat Stud Fees:</strong> Typical fees range from $150-$1,000 depending on breed, bloodline, and champion status. Many stud cat owners provide dedicated breeding spaces.</p>
                            </div>
                        </Col>
                    </Row>

                    {/* How It Works Section */}
                    <Row className="mb-5">
                        <Col md={12} className="text-center mb-4">
                            <h2 className="fw-bold">How Our Breeding Platform Works</h2>
                            <p>Simple steps to find the perfect breeding match for your pet</p>
                        </Col>

                        <Col md={3} className="text-center mb-4 mb-md-0">
                            <div className="process-step p-3">
                                <div className="step-number mb-3">1</div>
                                <h4>Create Profile</h4>
                                <p>Register your pet with photos, breed information, and health certifications</p>
                            </div>
                        </Col>
                        <Col md={3} className="text-center mb-4 mb-md-0">
                            <div className="process-step p-3">
                                <div className="step-number mb-3">2</div>
                                <h4>Browse Matches</h4>
                                <p>Find compatible breeding partners that match your criteria</p>
                            </div>
                        </Col>
                        <Col md={3} className="text-center mb-4 mb-md-0">
                            <div className="process-step p-3">
                                <div className="step-number mb-3">3</div>
                                <h4>Connect</h4>
                                <p>Message potential matches and discuss breeding arrangements</p>
                            </div>
                        </Col>
                        <Col md={3} className="text-center">
                            <div className="process-step p-3">
                                <div className="step-number mb-3">4</div>
                                <h4>Arrange Breeding</h4>
                                <p>Finalize details, payments, and breeding contracts securely</p>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>

            {/* Breeding Guides Section */}
            <section className="guides-section py-5 bg-light">
                <Container>
                    <Row className="mb-5">
                        <Col md={12} className="text-center mb-4">
                            <h2 className="fw-bold">Professional Breeding Guides</h2>
                            <p>Expert resources for responsible dog and cat breeding</p>
                        </Col>
                    </Row>

                    <Row className="mb-5">
                        <Col md={6} className="mb-4 mb-md-0">
                            <div className="guide-card h-100 p-4 border rounded bg-white shadow-sm">
                                <h3 className="text-primary mb-3">Dog Breeding Guide for Beginners</h3>
                                <p>Essential steps for safe and responsible dog breeding:</p>
                                <ol className="guide-list">
                                    <li><strong>Health Verification:</strong> Ensure your dog meets breed standards with necessary health clearances</li>
                                    <li><strong>Cycle Timing:</strong> Understand your female's reproductive cycle and optimal breeding time</li>
                                    <li><strong>Stud Selection:</strong> Find a compatible, health-tested stud through our verified listings</li>
                                    <li><strong>Whelping Preparation:</strong> Set up proper resources for birth and puppy care</li>
                                    <li><strong>Registration:</strong> Register your breeding program with appropriate kennel clubs</li>
                                </ol>
                                <p>Our app provides detailed guides on <strong>how to stud your dog for the first time</strong>, including breeding techniques and proper introduction protocols.</p>
                            </div>
                        </Col>
                        <Col md={6}>
                            <div className="guide-card h-100 p-4 border rounded bg-white shadow-sm">
                                <h3 className="text-primary mb-3">Cat Breeding Guide for Beginners</h3>
                                <p>Follow these essential guidelines for responsible cat breeding:</p>
                                <ol className="guide-list">
                                    <li><strong>Age & Health:</strong> Ensure your cat is 1-2 years old and meets breed standards</li>
                                    <li><strong>Heat Recognition:</strong> Identify signs of heat in female cats (increased affection, vocalization)</li>
                                    <li><strong>Stud Selection:</strong> Choose a registered, health-tested male through our verified listings</li>
                                    <li><strong>Environment:</strong> Prepare a safe, calm space for mating and pregnancy</li>
                                    <li><strong>Kitten Care:</strong> Learn about feline pregnancy and kitten development</li>
                                </ol>
                                <p>Our platform provides comprehensive resources on <strong>cat breeding seasons</strong>, regulations, and best practices for ethical breeding.</p>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>

            {/* Local Services Section */}
            <section className="local-services-section py-5">
                <Container>
                    <Row className="mb-4">
                        <Col md={12} className="text-center">
                            <h2 className="fw-bold">Local Breeding Services Near You</h2>
                            <p className="lead">Our location-based search connects you with nearby breeding services</p>
                        </Col>
                    </Row>

                    <Row>
                        <Col md={3} className="mb-4">
                            <div className="service-item text-center p-3 border rounded shadow-sm h-100">
                                <div className="service-icon mb-3">🐕</div>
                                <h4>Dog Stud Services Near Me</h4>
                                <p>Connect with local, verified stud dog owners for convenient breeding arrangements.</p>
                            </div>
                        </Col>
                        <Col md={3} className="mb-4">
                            <div className="service-item text-center p-3 border rounded shadow-sm h-100">
                                <div className="service-icon mb-3">🐈</div>
                                <h4>Cat Stud Services Near Me</h4>
                                <p>Find quality male cats available for breeding in your area.</p>
                            </div>
                        </Col>
                        <Col md={3} className="mb-4">
                            <div className="service-item text-center p-3 border rounded shadow-sm h-100">
                                <div className="service-icon mb-3">🏆</div>
                                <h4>Dog Breeders Near Me</h4>
                                <p>Discover local kennels, certified breeders and breeding consultants.</p>
                            </div>
                        </Col>
                        <Col md={3} className="mb-4">
                            <div className="service-item text-center p-3 border rounded shadow-sm h-100">
                                <div className="service-icon mb-3">🥇</div>
                                <h4>Cat Breeders Near Me</h4>
                                <p>Connect with catteries and feline breeding specialists in your vicinity.</p>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>

            {/* Ethical Breeding Section */}
            <section className="ethical-breeding-section py-5 bg-light">
                <Container>
                    <Row className="mb-4">
                        <Col md={12} className="text-center">
                            <h2 className="fw-bold">Responsible Breeding Practices</h2>
                            <p>At Pets Home, we promote ethical breeding that prioritizes animal welfare and genetic health</p>
                        </Col>
                    </Row>

                    <Row>
                        <Col md={8} className="mx-auto">
                            <div className="breeding-ethics p-4 border rounded bg-white shadow-sm">
                                <h3 className="text-primary mb-3">Our Ethical Breeding Standards</h3>
                                <div className="row">
                                    <div className="col-md-6">
                                        <ul className="ethics-list">
                                            <li><strong>Health Testing:</strong> Comprehensive screening for hereditary conditions</li>
                                            <li><strong>Temperament:</strong> Breeding only sound, stable animals</li>
                                            <li><strong>Female Care:</strong> Limited breeding frequency to protect health</li>
                                        </ul>
                                    </div>
                                    <div className="col-md-6">
                                        <ul className="ethics-list">
                                            <li><strong>Age Requirements:</strong> Never breeding too young or too old</li>
                                            <li><strong>Contracts:</strong> Detailed breeding agreements and health guarantees</li>
                                            <li><strong>Socialization:</strong> Proper care and socialization for all offspring</li>
                                        </ul>
                                    </div>
                                </div>
                                <p className="mt-3">While some critics question breeding practices, we believe responsible breeding preserves breed characteristics and promotes healthy genetics when done correctly. Our platform enforces these standards to ensure the best outcomes for pets and owners.</p>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>

            {/* Resources Section */}
            <section className="resources-section py-5">
                <Container>
                    <Row className="mb-4">
                        <Col md={12} className="text-center">
                            <h2 className="fw-bold">Comprehensive Breeding Resources</h2>
                            <p>Everything you need for successful and responsible breeding</p>
                        </Col>
                    </Row>

                    <Row>
                        <Col md={6} className="mb-4">
                            <div className="resource-card p-4 border rounded shadow-sm h-100">
                                <h3 className="text-primary mb-3">Stud Services Wanted</h3>
                                <p>Looking for specific breeding partners? Our platform allows you to:</p>
                                <ul>
                                    <li>Post requirements for specific stud dog breeds</li>
                                    <li>Search for particular genetic traits or colorations</li>
                                    <li>Find championship bloodlines for your breeding program</li>
                                    <li>Connect with verified breeders who meet your health criteria</li>
                                </ul>
                                <p>Our matching system helps you find the perfect stud dog or cat based on your specific breeding goals.</p>
                            </div>
                        </Col>
                        <Col md={6} className="mb-4">
                            <div className="resource-card p-4 border rounded shadow-sm h-100">
                                <h3 className="text-primary mb-3">Breeding Tools & Resources</h3>
                                <p>Our app provides comprehensive breeding resources:</p>
                                <ul>
                                    <li><strong>Breeding Charts:</strong> Track optimal breeding times</li>
                                    <li><strong>Educational Videos:</strong> Step-by-step breeding guidance</li>
                                    <li><strong>Health Records:</strong> Document and share important health clearances</li>
                                    <li><strong>Stud Registry:</strong> Access verified breeding males</li>
                                    <li><strong>Seasonal Guides:</strong> Information on breeding cycles and timing</li>
                                    <li><strong>Legal Resources:</strong> Breeding regulations in your area</li>
                                </ul>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>

            {/* Testimonials Section */}
            <section className="testimonials-section py-5 bg-light">
                <Container>
                    <Row className="mb-4">
                        <Col md={12} className="text-center">
                            <h2 className="fw-bold">Success Stories from Breeders</h2>
                            <p>Hear from dog and cat breeders who found perfect matches on our platform</p>
                        </Col>
                    </Row>

                    <Row>
                        <Col md={4} className="mb-4">
                            <div className="testimonial-card p-4 border rounded bg-white shadow-sm h-100">
                                <div className="testimonial-rating mb-3">⭐⭐⭐⭐⭐</div>
                                <p className="testimonial-text">"As a professional Golden Retriever breeder, finding health-tested studs used to be challenging. The Pets Home app connected me with the perfect stud dog just 20 minutes away, with all health clearances verified."</p>
                                <div className="testimonial-author mt-3">
                                    <p className="mb-0"><strong>Sarah M.</strong></p>
                                    <p className="small text-muted">Dog Breeder, California</p>
                                </div>
                            </div>
                        </Col>
                        <Col md={4} className="mb-4">
                            <div className="testimonial-card p-4 border rounded bg-white shadow-sm h-100">
                                <div className="testimonial-rating mb-3">⭐⭐⭐⭐⭐</div>
                                <p className="testimonial-text">"The Bengal cat stud I found through this app was exactly what my breeding program needed. The platform made it easy to verify health testing, discuss terms, and arrange the breeding. Highly recommended!"</p>
                                <div className="testimonial-author mt-3">
                                    <p className="mb-0"><strong>Michael T.</strong></p>
                                    <p className="small text-muted">Cat Breeder, Oregon</p>
                                </div>
                            </div>
                        </Col>
                        <Col md={4} className="mb-4">
                            <div className="testimonial-card p-4 border rounded bg-white shadow-sm h-100">
                                <div className="testimonial-rating mb-3">⭐⭐⭐⭐⭐</div>
                                <p className="testimonial-text">"As a new French Bulldog breeder, the educational resources and mentor connections I found on Pets Home were invaluable. Found a perfect stud and received guidance throughout the entire process."</p>
                                <div className="testimonial-author mt-3">
                                    <p className="mb-0"><strong>Jessica R.</strong></p>
                                    <p className="small text-muted">Dog Breeder, Texas</p>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>

            {/* CTA Section */}
            <section className="cta-section py-5 bg-primary text-white">
                <Container>
                    <Row>
                        <Col md={10} className="mx-auto text-center">
                            <h2 className="display-5 fw-bold mb-3">Find Your Perfect Breeding Match Today</h2>
                            <p className="lead mb-4">Join thousands of responsible dog breeders and cat breeders who've found ideal breeding partners. Download the Pets Home app now!</p>

                            <h5 className="text-center font-weight-bold">{t('global.h5_dwonload')}</h5>
                            <div className="d-flex justify-content-center">
                                <a href="https://play.google.com/store/apps/details?id=com.app.petshome" target="_blank" rel="noopener noreferrer" className="mr-3" title="Download Pets Home App from Google Play Store">
                                    <img style={{ width: '180px', height: 'auto', marginRight: "10px" }} src="/google-play-badge.svg" alt="Download Pets Home App on Google Play" />
                                </a>
                                <a href="https://apps.apple.com/app/apple-store/id1549828591?pt=581834&ct=desktop&mt=8" target="_blank" rel="noopener noreferrer" title="Download Pets Home App from Apple App Store">
                                    <img style={{ width: '180px', height: 'auto' }} src="/app-store-badge.svg" alt="Download Pets Home App on App Store" />
                                </a>
                            </div>
                            <div className="d-flex justify-content-center">
                                {/* <small> {t('rated')} </small> */}
                                <div>
                                    <FontAwesomeIcon icon={faStar} color="gold" />
                                    <FontAwesomeIcon icon={faStar} color="gold" />
                                    <FontAwesomeIcon icon={faStar} color="gold" />
                                    <FontAwesomeIcon icon={faStar} color="gold" />
                                    <FontAwesomeIcon icon={faStar} color="gold" />
                                </div>
                            </div>
                            <div className="d-flex justify-content-center mt-4">
                                <img style={{ width: '130px', height: 'auto', marginRight: '10px' }} src="/android-adobe-express-qr-code.png" alt="Android QR Code" className="mr-3" />
                                <img style={{ width: '130px', height: 'auto' }} src="/ios-express-qr-code.png" alt="iOS QR Code" />
                            </div>
                            <p className="text-center mt-3 d-none d-md-block">{t('Scan the QR codes below for quick access:')}</p>


                            {/* Social Sharing Buttons */}
                            <div className="social-sharing text-center my-4">
                                <p>{t('global.share_p')}</p>
                                <a href="https://www.facebook.com/sharer/sharer.php?u=https://www.petshome.app/" target="_blank" rel="noopener noreferrer">
                                    <FontAwesomeIcon icon={faFacebook} size="2x" className="mx-2" />
                                </a>
                                <a href="https://twitter.com/intent/tweet?url=https://www.petshome.app/&text=Sell%20Your%20Pet%20Online%20for%20Free%20with%20Pets%20Home%20App" target="_blank" rel="noopener noreferrer">
                                    <FontAwesomeIcon icon={faTwitter} size="2x" className="mx-2" />
                                </a>
                                <a href="https://www.instagram.com/petshomeapp/" target="_blank" rel="noopener noreferrer">
                                    <FontAwesomeIcon icon={faInstagram} size="2x" className="mx-2" />
                                </a>
                                <a href="https://www.pinterest.com/petshomeapp/" target="_blank" rel="noopener noreferrer">
                                    <FontAwesomeIcon icon={faPinterest} size="2x" className="mx-2" />
                                </a>
                                <a href="https://www.youtube.com/channel/UCTjh3nmz0cVGaX0MnHl6elA" target="_blank" rel="noopener noreferrer">
                                    <FontAwesomeIcon icon={faYoutube} size="2x" className="mx-2" />
                                </a>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>

            {/* FAQ Section */}
            <section className="faq-section py-5">
                <Container>
                    <Row className="mb-4">
                        <Col md={12} className="text-center">
                            <h2 className="fw-bold">Frequently Asked Questions</h2>
                            <p>Common questions about dog and cat breeding services</p>
                        </Col>
                    </Row>

                    <Row>
                        <Col lg={8} className="mx-auto">
                            <div className="accordion" id="breedingFAQ">
                                <div className="accordion-item mb-3 border rounded shadow-sm">
                                    <h3 className="accordion-header">
                                        <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#faqOne">
                                            When do you pay for a stud dog service?
                                        </button>
                                    </h3>
                                    <div id="faqOne" className="accordion-collapse collapse show" data-bs-parent="#breedingFAQ">
                                        <div className="accordion-body">
                                            Payment for dog stud services typically occurs at the time of breeding, though some breeders may require a deposit upfront. The full fee is usually due when the breeding is confirmed successful. Our platform facilitates secure payment processing and breeding agreements to protect both parties.
                                        </div>
                                    </div>
                                </div>

                                <div className="accordion-item mb-3 border rounded shadow-sm">
                                    <h3 className="accordion-header">
                                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#faqTwo">
                                            What is the minimum age for cat breeding?
                                        </button>
                                    </h3>
                                    <div id="faqTwo" className="accordion-collapse collapse" data-bs-parent="#breedingFAQ">
                                        <div className="accordion-body">
                                            Female cats should be at least 1-2 years old before breeding to ensure proper physical development. Males can breed from about 12 months but are often more mature at 18-24 months. Responsible breeding considers the age and health of both cats to ensure optimal outcomes.
                                        </div>
                                    </div>
                                </div>

                                <div className="accordion-item mb-3 border rounded shadow-sm">
                                    <h3 className="accordion-header">
                                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#faqThree">
                                            What health testing is required for dog breeding?
                                        </button>
                                    </h3>
                                    <div id="faqThree" className="accordion-collapse collapse" data-bs-parent="#breedingFAQ">
                                        <div className="accordion-body">
                                            Required health testing varies by breed but commonly includes hip and elbow evaluations, eye certifications, cardiac exams, and genetic tests for breed-specific conditions. All dogs listed on our platform must have appropriate health clearances verified, ensuring you're breeding with healthy, tested animals.
                                        </div>
                                    </div>
                                </div>

                                <div className="accordion-item mb-3 border rounded shadow-sm">
                                    <h3 className="accordion-header">
                                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#faqFour">
                                            How to stud your dog for the first time?
                                        </button>
                                    </h3>
                                    <div id="faqFour" className="accordion-collapse collapse" data-bs-parent="#breedingFAQ">
                                        <div className="accordion-body">
                                            For first-time stud services, ensure your dog has passed all relevant health screenings, create a calm environment for breeding, have experienced handlers present, and allow the dogs to become comfortable with each other before breeding. Our app provides detailed guidance for first-time dog breeders.
                                        </div>
                                    </div>
                                </div>

                                <div className="accordion-item mb-3 border rounded shadow-sm">
                                    <h3 className="accordion-header">
                                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#faqFive">
                                            Are breeding services regulated?
                                        </button>
                                    </h3>
                                    <div id="faqFive" className="accordion-collapse collapse" data-bs-parent="#breedingFAQ">
                                        <div className="accordion-body">
                                            Breeding regulations vary by location. Many jurisdictions require permits, limit the number of breeding animals, or have specific requirements for facilities. Our platform helps you understand and comply with local regulations. We promote only legal and ethical breeding practices.
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>

            {/* Footer CTA */}
            <section className="footer-cta py-5 bg-light">
                <Container>
                    <Row>
                        <Col md={8} className="mx-auto text-center">
                            <h2 className="fw-bold mb-3">Ready to Find the Perfect Breeding Partner?</h2>
                            <p className="mb-4">Join our community of responsible dog and cat breeders today.</p>

                        </Col>
                    </Row>
                </Container>
            </section>
        </>
    );
};

export default PetBreeding;